var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronUp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.94 15.7276C18.5495 16.1181 17.9163 16.1181 17.5258 15.7276L12 10.2018L6.47423 15.7276C6.08371 16.1181 5.45054 16.1181 5.06002 15.7276C4.66949 15.337 4.66949 14.7039 5.06002 14.3133L10.9493 8.42407C11.0824 8.28617 11.2422 8.17495 11.42 8.09804C11.4202 8.09794 11.4204 8.09785 11.4207 8.09775L11.8171 9.01579L11.4193 8.09833C11.4195 8.09823 11.4198 8.09814 11.42 8.09804C11.6037 8.01849 11.8011 7.97791 12 7.97791C12.1991 7.97791 12.3968 8.01859 12.5807 8.09833L12.1829 9.01579L12.5794 8.09775C12.7574 8.17467 12.9174 8.28599 13.0507 8.42406L13.0427 8.41608L12.3356 9.12319L13.0646 8.43862C13.06 8.43373 13.0554 8.42888 13.0507 8.42406L18.94 14.3133C19.3305 14.7039 19.3305 15.337 18.94 15.7276Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ChevronUp.415e602a1dd8ed57aa617f415a7aab33.svg";